import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.benutzer-nutzungsbedingungen';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerNutzungsbedingungenEffects {

    BenutzerNutzungsbedingungen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_BENUTZER_NUTZUNGSBEDINGUNGEN),
        mergeMap((x: ac.GetBenutzerNutzungsbedingungenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getBenutzerNutzungsbedingungen().pipe(
                map((result: any) => {
                    return new ac.GetBenutzerNutzungsbedingungenErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetBenutzerNutzungsbedingungenFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungQueryService);
        }
        return this.service;
    }
}
